import React from "react";
import { useSelector } from "react-redux";
import { selectPageById } from "../reducers";
import SectionContainer from "./SectionContainer";

const Page = ({ id }) => {
	const page = useSelector((state) => selectPageById(state, id));

	return page ? <SectionContainer pageId={id} /> : <></>;
};

export default Page;
